export const TABS = {
	viewOptions: { value: 'viewOptions', text: 'Purchased options' },
	editOptions: { value: 'editOptions', text: 'Add options', highlight: true },
	receipts: { value: 'receipts', text: 'Receipts' }
};
